import React, { FC, ReactElement } from 'react';
import { Title } from '@npm-registry/eapteka-ui';
import styles from './List.scss';

interface ListProps {
  /**
   * Заголовок списка товаров
   */
  title?: string;

  /**
   * Список продуктов
   */
  children: ReactElement[];
}

export const List: FC<ListProps> = ({
  title,
  children
}) => {
  return (
    <div>
      {title && (
        <Title
          tag="h3"
          weight="semiBold"
          className={styles.title}
        >
          {title}
        </Title>
      )}
      {children}
    </div>
  );
};
